import axios from "axios";

import Config from "../config/Config";

const config = new Config();

export default axios.create({
    baseURL: config.HOME_URL,
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Methods": "GET, POST",
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache"
    }
});
